import { SelectOptionProps } from '@innovationnorway/component-library';
import { ClusterUserDto } from 'src/api/v2';
import { roleConstants } from 'src/features/roles/constants';
import { UseUsersOptions, useUsersQuery } from 'src/features/users';

export type SivaAdvisorOption = SelectOptionProps & { fullName: string };

// Keyed on the cached users array so the filter/map/sort runs once and is shared by every consumer.
const advisorOptionsCache = new WeakMap<object, SivaAdvisorOption[]>();

const getAdvisorOptions = (users: ClusterUserDto[]): SivaAdvisorOption[] => {
  const cached = advisorOptionsCache.get(users);
  if (cached) return cached;

  const advisorOptions = users
    .filter(
      (user) =>
        user.role?.code?.startsWith(roleConstants.INTERNAL) ||
        user.role?.code?.startsWith(roleConstants.PRIVILEGED),
    )
    .map(
      (user) =>
        ({
          value: user.id,
          text: `${user.firstName} ${user.lastName} (${user.emailAddress})`,
          fullName: `${user.firstName} ${user.lastName}`,
        }) satisfies SivaAdvisorOption,
    )
    .sort((a, b) => a.text.localeCompare(b.text));

  advisorOptionsCache.set(users, advisorOptions);
  return advisorOptions;
};

const useAdvisorOptions = (options?: UseUsersOptions) => {
  const { users } = useUsersQuery(options);

  return {
    advisorOptions: getAdvisorOptions(users),
  };
};
export default useAdvisorOptions;
